import { HttpClient } from '@core/httpClient';
import { END_POINTS } from '@services/urls';

import { buildPathWithParams } from '@utils/urls';

import { TSupportProfileDetails } from './types';

export class AstroPayProService {
  public static getStoreDetails = async (storeTag: string): Promise<TSupportProfileDetails> => {
    try {
      const response = await HttpClient.GET<TSupportProfileDetails>({
        url: buildPathWithParams(END_POINTS.storeDetails, { storeTag }),
        useQueryParams: false,
      });

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
